<div class="row form" *ngIf="book != null">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i> Balance Grupo
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
      <div class="card m-b-20" [ngClass]="{'border-schedule-private': book.typevehicle_tour == vehicle_private }">
        <div class="card-body p-l-5 p-r-5 p-t-5 p-b-0 faq-box boder-left-{{book.status_group.class}}">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
              <div id="test" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left bold">Destino</div>
                  <div class="child-right bold">
                    {{book.tour_data.description}}
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Estado</div>
                  <div class="child-right">
                    <span class="badge f-s-12 badge-{{book.status_group.class}}">{{book.status_group.message}}</span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Código</div>
                  <div class="child-right">
                    <span class="bold color-link">{{book.code}}</span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Fecha de salida</div>
                  <div class="child-right">
                    {{book.date_departure}}
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Guía de viaje</div>
                  <div class="child-right">
                    {{book.guide_data.fullname}} - CEL: {{book.guide_data.cellphone}}
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Transporte</div>
                  <div class="child-right">
                    {{book.transport_data.owner}} - CEL: {{book.transport_data.cellphone}}
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Capacidad Transporte</div>
                  <div class="child-right">
                    {{book.transport_data.capacity}} - placa:
                    <span>{{book.transport_data.license_plate}}</span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Pasajeros</div>
                  <div class="child-right bold">
                    {{book.capacity_selected}} <span class="m-l-5">seleccionados</span>
                    <ng-container *ngIf="book.typevehicle_tour == vehicle_private">
                      <span class="m-l-10">
                        <span class="badge badge-orange badge-schedule-private f-s-10"><i
                            class="fas fa-bolt m-r-5"></i>Servicio Privado</span>
                      </span>
                    </ng-container>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Observaciones</div>
                  <div class="child-right">
                    <span>{{book.observations}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-sm mb-0">
            <thead class="thead-default">
              <tr>
                <th>Responsable y Código</th>
                <th class="text-center">Etiqueta</th>
                <th>Hotel / Ubicacion</th>
                <th class="text-center">N° PAX</th>
                <th class="text-center position-relative">P.Operativo(x PAX) <span class="required"></span></th>
                <th class="text-center">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="bookings.length > 0">
                <ng-container *ngFor="let item of bookings; let index_ = index">
                  <tr [ngClass]="{'text-danger': book.date_departure != item.date_assigned }">
                    <td class="f-s-13">
                      {{item.client}}
                      <p class="f-s-10 bold m-b-0" *ngIf="item.is_received"><span
                          class="badge badge-success">Recibido</span> | {{item.agency_reponsible}}</p>
                      <p class="m-b-2">
                        <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                        <span class=" f-s-11 bold pointer">{{item.code}}</span>
                      </p>
                    </td>
                    <td class="text-center">{{item.reference_voucher}}</td>
                    <td class="f-s-13">{{item.reference_location}}</td>
                    <td class="text-center f-s-13">
                      {{item.quantity}}
                    </td>
                    <td class="d-flex justify-center">
                      <input style="width: auto;" type="text" id="detail_price_corporate{{index_}}" numeric
                        value="{{item.price_corporate}}" class="form-control sale__input text-center"
                        (keyup)="changePriceCorporate($event.target, index_)" onclick="click_input(this)">
                    </td>
                    <td class="text-center">
                      {{toolsService.momeySol()}}{{item.total_operational}}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="text-right bold" style="font-size: 15px !important;">
                  TOTAL COSTEO OPERATIVO
                </td>
                <td class="text-success text-center" style="font-size: 15px !important;">
                  {{toolsService.momeySol()}}{{total_operational_group}}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="m-b-10">
          <div class="col-lg-12 m-t-10">
            <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i> Egresos/gastos operativos
            </p>
            <div class="row">
              <div class="form-group col-lg-3">
                <label>Conceptos</label>
                <select class="form-control" id="conceptSelected" [(ngModel)]="conceptSelected" [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let item of concepts" [value]="item.id">{{ item.description }}</option>
                </select>
              </div>
              <div class="form-group col-lg-2">
                <label>.</label>
                <button type="button" class="btn btn-info" (click)="addExpenseOperational()">Agregar Item</button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>Item concepto</th>
                    <th class="position-relative text-center">Cantidad <span class="required"></span></th>
                    <th class="position-relative text-center">CostoRef. S/ <span class="required"></span></th>
                    <th>Obs.</th>
                    <th class="text-center">Subtotal</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of expenses_operational; let index_ = index">
                    <tr>
                      <td>
                        {{item.description}}
                      </td>
                      <td>
                        <input type="text" id="expense_quantity{{index_}}" numeric value="{{item.quantity}}"
                          class="form-control sale__input text-center"
                          (keyup)="changeExpenseOperationalQuantity($event.target, index_)" onclick="click_input(this)">
                      </td>
                      <td>
                        <input type="text" id="expense_price_operational{{index_}}" numeric
                          value="{{item.price_operational}}" class="form-control sale__input text-center"
                          (keyup)="changeExpenseOperationalPriceOperational($event.target, index_)"
                          onclick="click_input(this)">
                      </td>
                      <td>
                        <input type="text" id="expense_observation{{index_}}" value="{{item.observation}}"
                          (keyup)="changeExpenseOperationalObservation($event.target, index_)"
                          class="form-control sale__input text-left">
                      </td>
                      <td class="text-center">
                        {{item.total_operational}}
                      </td>
                      <td>
                        <i class="far fa-trash-alt pointer f-s-15 text-danger"
                          (click)="removeExpenseOperational(item.id, index_)"></i>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" class="text-right bold" style="font-size: 15px !important;">
                      TOTAL GASTOS
                    </td>
                    <td class="text-danger text-center" style="font-size: 15px !important;">
                      {{toolsService.momeySol()}}{{total_expense_operational}}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <ng-container *ngIf="expenses_operational.length > 0">
          <div class="m-b-40 p-b-30">
            <div class="col-lg-12 m-t-10">
              <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i>Resumen balance
              </p>
              <div class="row ">
                <div class="form-group col-lg-3">
                  <label>TOTAL OPERATIVO</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </div>
                    <input type="text" class="form-control text-success text-center" value="{{total_operational_group}}"
                      disabled>
                  </div>
                </div>
                <div class="form-group col-lg-1">
                  <label style="color: transparent;">.</label>
                  <input type="text" class="form-control text-center" value="-" disabled>
                </div>
                <div class="form-group col-lg-3">
                  <label>TOTAL GASTOS</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </div>
                    <input type="text" class="form-control text-danger text-center"
                      value="{{total_expense_operational}}" disabled>
                  </div>
                </div>
                <div class="form-group col-lg-1">
                  <label style="color: transparent;">.</label>
                  <input type="text" class="form-control text-center" value="=" disabled>
                </div>
                <div class="form-group col-lg-3">
                  <label>REF.UTILIDAD GANADA</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </div>
                    <input type="text" class="form-control text-primary text-center"
                      value="{{total_operational_group- total_expense_operational}}" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="form-group col-lg-12 form__footerBtn m-t-30">
          <div class="text-right">
            <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
            <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
              <i class="far fa-save m-r-5"></i>
              <ng-container *ngIf="!isEdit">
                GENERAR BALANCE
              </ng-container>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
